module.exports = "/_next/static/images/a7b65bcad97d61c776b731c5961109df-phone-lg.png";